import { ProcessComment, RenderFormatDescription, RenderFormatProcessTemplateNode, RenderProcessTemplateNode } from '@/types/process';

export const getFormatData = (node: RenderProcessTemplateNode): RenderFormatProcessTemplateNode => {
  const qType = node?.title?.approvalType;
  let commentsList = node?.comments || [];
  if (qType === 'PARALLEL' || qType === 'OR') {
    commentsList = [
      ...commentsList.filter((el: ProcessComment) => el.complete),
      ...commentsList.filter((el: ProcessComment) => !el.complete),
    ];
  }
  const data: RenderFormatDescription[] = commentsList?.map((el: ProcessComment) => {
    if (el.message) {
      el.message = JSON.parse(el.message);
    } else {
      el.message = {};
    }
    const type = el.complete ? '1' : '0';
    return {
      ...el,
      ...el.message,
      type,
      notice: !type && qType === 'SEQUENTIAL',
    };
  });
  // 不同意
  const isRefuse = data.filter((el: RenderFormatDescription) => el.auditType === 0).length > 0;
  return {
    ...node,
    description: data,
    isRefuse,
  };
};


export const getEndNode = (id: any, edges: any, nodes: any) => {
  let newNode: any = null;
  const findEndNode = (ativeId: any, edgeList: any, nodeList: any) => {
    const edgeItem = edgeList.find((item: any) => item.source === ativeId);
    const targetId = edgeItem?.target;
    const targetNode = nodeList.find((item: any) => item.id === targetId);
    if (!targetNode) {
      return;
    }
    if (targetNode?.shape === 'end-node') {
      newNode = targetNode;
      return;
    }
    findEndNode(targetId, edgeList, nodeList);
  };
  findEndNode(id, edges, nodes);
  return newNode;
};
